<template>
  <div>
    <!--弹出框-->
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
      style="height: 100%;">
      <el-dialog class="dialogwidth" :modal="false" :title="titmc" :visible.sync="dialogVisible" v-dialogDrag
        :before-close="handleClose" :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false">
        <el-row>
          <el-col :span="24">
            <el-form-item type="type" label="淤地坝名称" prop="ydbmc">
              <el-input type="type" class="from-el-input" placeholder="淤地坝名称" v-model.trim="ruleForm.ydbmc"
                :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="titna">
              <span class="addSpan">附件</span>
            </div>
            <div class='fujian'>
              <el-upload class="upload-demo" drag action="" multiple :on-remove="handleRemove" :on-change='changes'
                :file-list="fileList" :limit="5" :auto-upload='false'>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </el-upload>
              <div class='fujian fujians' v-if="filetabledata.length!=0">
                <ul class="fjhxlist">
                  <li v-for="(item,i) in filetabledata" :key="i">
                    <div class="names" style="text-align: left;">{{item.sourceName}}</div>
                    <div class="names cz">
                      <el-button type="primary" icon="el-icon-download" circle @click="DownloadFile(i,item)"
                        class="btnmargin"></el-button>
                      <el-button type="success" icon="el-icon-delete" v-if="states!='ck'" circle
                        @click="deletesfile(i,item)" class="btnmargin"></el-button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-form-item>
            <el-button @click="cancel()" v-if="states != 'ck'" type="warning">取 消</el-button>
            <el-button type="success" @click="xzdeteRmine('ruleForm','xz')">上 传</el-button>
          </el-form-item>
        </span>
      </el-dialog>
    </el-form>
    <!--弹出框-->
  </div>
</template>
<script>
  import {
    ydbjbxxQuery,
    savePic,
    deleteFile
  } from "@/api/api";
  import axios from 'axios'
  export default {
    props: {
      mystate: Array,
    },
    data() {
      return {
        tokens: this.$store.state.token,
        dialogVisible: true, //弹出框显示
        titmc: '附件上传',
        ruleForm: {
          ydbmc: '', //淤地坝名称
          ydbCode: '', //淤地坝编码
        },
        rules: {
          ydbmc: [{
              required: true,
              message: '请输入必填项',
              trigger: 'blur'
            },
            {
              min: 1,
              max: 50,
              message: '长度在 1 到 50 个字符',
              trigger: 'blur'
            }
          ],
        },
        states: '',
        fileList: [], //图片
        filetabledata: [], //回显附件
        row: null,
        fileUrl: '',
      }
    },
    mounted() {
      //实例挂载后
      this.states = this.mystate[0];
      this.row = this.mystate[1];
      this.ruleForm.ydbmc = this.mystate[1].ydbName; //淤地坝名称
      this.ruleForm.ydbCode = this.mystate[1].ydbCode; //淤地坝编号
      this.filetabledata = this.mystate[1].fileList;
    },
    methods: {
      //函数
      handleClose(done) {
        this.dialogVisible = false;
        this.$emit("getcancel", {
          "dialogVisible": this.dialogVisible
        })
      },
      cancel() { //取消
        this.dialogVisible = false;
        this.$emit("getcancel", {
          "dialogVisible": this.dialogVisible
        })
      },
      xzdeteRmine(formName, states) { //确定
        this.$refs[formName].validate(valid => {
          if (valid) {
            let config = {
              headers: {
                "Content-Type": "multipart/form-data",
                "Access-Token": this.tokens
              },
            }; // 添加请求头
            if (this.fileList.length != 0) {
              let formData = new FormData();
              this.fileList.forEach((el, index) => {
                formData.append('file', el); // 'file' 可变 相当于 input 表单的name 属性
              });

              axios.post('/userApi/minio/updateFileMulti', formData, config).then(res => {
                if (res.data.code == 200) {
                  this.$notify({
                    title: "提示",
                    message: res.data.message,
                    type: "success",
                  });
                  this.fileUrl = res.data;
                } else {
                  this.$notify({
                    title: "提示",
                    message: res.data.msg,
                    type: "warning",
                  });
                }
              }).catch(err => {});
            }

            let _this = this;
            setTimeout(function() {
              let params = {
                ydbName: _this.ruleForm.ydbmc, //淤地坝名称
                ydbCode: _this.ruleForm.ydbCode, //淤地坝编号
                fileList: _this.fileUrl, //附件
              };
              savePic(params).then((res) => {
                if (res.code === 200) {
                  _this.$notify({
                    title: "提示",
                    message: "提交成功",
                    type: "success"
                  });
                  _this.dialogVisible = false;
                  _this.$emit("adddata", {
                    dialogVisible: _this.dialogVisible
                  });
                } else {
                  _this.$notify({
                    title: "提示",
                    message: res.message,
                    type: "warning"
                  });
                }
              })
            }, 200)
          }
        });
      },

      DownloadFile(index, row) { //下载文件
        window.open("/userApi/minio/downloadFile/" + row.fileName);
      },
      deletesfile(index, row) { //删除文件
        let params = {
          id: row.id,
          fileName: row.fileName
        };
        deleteFile(params).then((res) => {
          if (res.code == 200) {
            this.$notify({
              title: '',
              message: res.message,
              type: 'success'
            });
            this.filetabledata.splice(index, 1)
          }
        })
      },

      handleRemove(file, fileList) { //删除文件
        for (let i = 0; i < this.fileList.length; i++) {
          if (file.name == this.fileList[i].name) {
            this.fileList.splice(this.fileList[i], 1);
          }
        }
      },
      changes(file, fileList) {
        let num = 1024.00;
        if (Number((file.size / Math.pow(num, 2)).toFixed(2)) > 10) {
          fileList.splice(fileList.length - 1, 1);
          this.$message.error('选择文件大于10M，请重新选择！');
        } else {
          this.fileList.push(file.raw);
        }
      },
    },
  }
</script>

<style scoped>
  .fujian {
    width: -webkit-calc(100% - 102px);
    width: -moz-calc(100% - 102px);
    width: calc(100% - 102px);
    float: left;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 10px;

  }

  .treebox {
    width: 100%;
    margin: 0;
  }

  >>>.el-dialog {
    width: 600px;
  }

  >>>.el-input.is-disabled .el-input__inner {
    color: #606266;
  }

  >>>.el-textarea.is-disabled .el-textarea__inner {
    color: #606266;
  }

  >>>.el-input--prefix .el-input__inner {
    padding-left: 30px;
  }
</style>
